import type { PropsWithChildren } from 'react'
import styles from './Step.module.css'

export const StepContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.container}>{children}</div>
)

export const StepContents = ({ children }: PropsWithChildren) => (
  <div className={styles.contents}>{children}</div>
)

export const StepTitleContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.titleContainer}>{children}</div>
)

export const StepTitle = ({ children }: PropsWithChildren) => (
  <h2 className={styles.title}>{children}</h2>
)

export const StepSubtitle = ({ children }: PropsWithChildren) => (
  <p className={styles.subtitle}>{children}</p>
)

export const StepFooter = ({ children }: PropsWithChildren) => (
  <div className={styles.footer}>{children}</div>
)

export const StepRSP = ({ children }: PropsWithChildren) => (
  <div className={styles.rsp}>{children}</div>
)
